@if (order$ | async; as order) {
  <div class="main-content">
    <!-- PAGE HEADER -->
    <div class="page-header">
      <h1 class="page-title">Order Details</h1>
      <!-- <button class="back-btn" (click)="goBack()">
      <i class="fas fa-level-down-alt fa-rotate-90" aria-hidden="true"></i>
    </button> -->
  </div>
  <div class="order-details">
    <div class="details-grid">
      <div class="detail-group">
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.orderNumber' | cxTranslate }}</div>
          <div class="detail-value large">{{ order.code | removeLeadingZeros }} </div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.brand' | cxTranslate }}</div>
          <div class="detail-value">{{ order.brand }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-value">
            <kn-br-common-address class="detail-label" [address]="order.soldTo" [isSoldTo]="true" [addressLabel]="'Sold To Address'">
            </kn-br-common-address>
          </div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.accountPhone' | cxTranslate }}</div>
          <div class="detail-value">{{ this.formatPhone(order.soldTo?.telephone) ? order.soldTo?.telephone : '-'}}</div>
        </div>
      </div>
      <div class="detail-group">
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.poNumber' | cxTranslate }}</div>
          <div class="detail-value">{{ order.purchaseOrderNumber ? order.purchaseOrderNumber : '-' }} </div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.orderType' | cxTranslate }}</div>
          <div class="detail-value">{{ order.orderType }} </div>
        </div>
        <div class="detail-item">
          <!-- <div class="detail-label">Ship To Address</div> -->
          <div class="detail-value">
            <kn-br-common-address class="detail-label" [address]="order.deliveryAddress" [addressLabel]="'Ship To Address'">
            </kn-br-common-address>
          </div>
        </div>
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.deliveryBlock' | cxTranslate }}</div>
          <div class="detail-value">{{ order.deliveryBlock ? order.deliveryBlock : '-' }}</div>
        </div>
        <!-- <div class="detail-item">
        <div class="detail-label">Broker Address</div>
        <div class="detail-value">
          <kn-br-common-address [address]="order.brokerAddress" [addressLabel]="'Broker Address'">
          </kn-br-common-address>
        </div>
      </div> -->
    </div>
    <div class="detail-group">
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.accountNumber' | cxTranslate }}</div>
        <div class="detail-value">{{ order.soldTo?.customerNumber | removeLeadingZeros }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.orderStatus' | cxTranslate }}</div>
        <div class="detail-value">{{ order.statusDisplay }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.jobNumber' | cxTranslate }}</div>
        <div class="detail-value">{{ order.jobName ? order.jobName : '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.shippingNotes' | cxTranslate }}</div>
        <div class="detail-value">{{ order.notes ? order.notes : '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.orderCreationDate' | cxTranslate }}</div>
        <div class="detail-value">{{ order.creationDate }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.orderTotal' | cxTranslate }}</div>
        <div class="detail-value currency">{{ order.totalPriceWithTax?.formattedValue }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'knbrOrderDetails.label.creditStatus' | cxTranslate }}</div>
        <div class="detail-value">{{ order.creditStatus }}</div>
      </div>
      @if (order.carlisleSaleDocs) {
        <div class="detail-item">
          <div class="detail-label">{{ 'knbrOrderDetails.label.downloadDocs' | cxTranslate }}</div>
          <div class="detail-value link">
            @for (doc of order.carlisleSaleDocs; track doc) {
              <a (click)="downloadPDF(doc)" class="doc-link cursor-pointer">
                {{ doc?.documentName ? doc?.documentName : '-' }}
              </a>
            }
          </div>
        </div>
      }
      <!-- <div class="detail-item res-btn">
      <div class="detail-label">Case Management</div>
      <button class="submit-case-btn" (click)="navigateToCaseCreation()" ngbTooltip="{{createCasetoolTipText}}"
        triggers="hover" placement="top-right">
        <img src="assets/images/create-case-icon.svg" class="pb-1">
        Submit Case
      </button>
    </div> -->
  </div>
</div>
</div>
<div class="action-slot">
  <cx-page-slot position="ActionSlot"></cx-page-slot>
</div>
</div>
}